<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{ title }}</div>-->
    <search-form-template
      :searchOptions="searchOptions"
      @searchSubmit="searchSubmit"
      @clear="clearSearch"
      :toolConfig="toolConfig"
      @btnCommon="exportExcel"
    ></search-form-template>

    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="盘点明细" name="blitem">
        <table-template ref="blitem" :tableOptions="blitem">
        </table-template>
      </el-tab-pane>
      <el-tab-pane label="盘点差异" name="difference">
        <table-template ref="difference" :tableOptions="difference"></table-template>
      </el-tab-pane>
      <el-tab-pane label="盘点漏盘" name="beLostBlitem">
        <table-template ref="beLostBlitem" :tableOptions="beLostBlitem"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import searchFormTemplate from '@/components/template/searchFormTemplate';
import tableTemplate from '@/components/template/tableTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower'

export default {
  mixins: [userPower],
  name: 'RoleManager',
  components: {
    tableTemplate,
    searchFormTemplate,
  },
  data() {
    return {
      activeTab: 'blitem',
      loading: false,
      treeConfig: {
        id: 'menuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: api.system.rolePrivilege,
          param: {roleId: ''}
        }
      },
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: '盘点批号',
            prop: 'batchOrderNo',
            type: 'input',
            span: 8,
            placeholder: '请输入盘点批号',
            inputWidth: '250px',
          }],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24,
          },
          // {
          //   label: '仓库',
          //   type: 'select',
          //   prop: 'warehouseId',
          //   url: api.warehouse.warehouse,
          //   param: {relateType: this.$utils.getSysUser().storeId?20:10},
          //   data: [],
          //   span: 12,
          // },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 8,
            data: [],
            isHasAll: true,
            change: this.storeChange,
            url: api.system.seStore
          },
          {
            label: '类别',
            type: 'cascader',
            prop: 'goodsCategoryId',
            valueKey: 'value',
            data: [],
            span: 8,
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
          {
            label: '品牌',
            type: 'select',
            prop: 'goodsBrandId',
            data: [],
            span: 8,
            // url: api.archives.brand,
          },
          {
            label: '供应商',
            type: 'select',
            prop: 'supplierId',
            data: [],
            span: 8,
            // url: api.archives.supplier,
          },
          {
            label: '商品',
            prop: 'otherName',
            type: 'input',
            isFuzzy: true,
            span: 8,
            placeholder: '条码/名称/自编码',
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '打印',
          code: 'print'
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel
        }
      ],
      // 盘点明细
      blitem: {
        showSummary: true,
        summaryColumns: ['blitemNum', 'amountInventory', 'inventoryNum', 'retailPrice'],
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '200',
            align: 'center'
          },
          {
            label: '盘点批号',
            prop: 'batchOrderNo',
            width: '230',
            align: 'center'
          },
          {
            label: '盘点单',
            prop: 'orderNo',
            width: '230',
            align: 'center'
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '200',
            align: 'center'
          },
          // {
          //   label: '自编码',
          //   prop: 'artNo',
          //   width: '150',
          //   align: 'center'
          // },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '150',
            align: 'center'
          },
          {
            label: '盘点数量',
            prop: 'blitemNum',
            width: '120',
            align: 'center'
          },
          {
            label: '盘点金额',
            prop: 'amountInventory',
            width: '120',
            align: 'center'
          },
          {
            label: '系统库存',
            prop: 'inventoryNum',
            width: '120',
            align: 'center'
          },
          {
            label: '零售价',
            prop: 'retailPrice',
            width: '80',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '80',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '80',
            align: 'center'
          },
          {
            label: '商品类别',
            prop: 'goodsCategoryName',
            width: '120',
            align: 'center'
          },
          {
            label: '品牌',
            prop: 'goodsBrandName',
            width: '120',
            align: 'center'
          },
          {
            label: '供应商',
            prop: 'supplierName',
            width: '150',
            align: 'center'
          },
          // {
          //   label: '成本价',
          //   prop: 'purchasePrice',
          //   width: '80',
          //   align: 'center'
          // },

        ],
        url: api.warehouse.blitemDetail
      },
      // 差异明细
      difference: {
        showSummary: true,
        summaryColumns: ['blitemNum', 'inventoryNum', 'quantityVariance', 'lossAmount', 'amountInventory'],
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '200',
            align: 'center'
          },
          {
            label: '盘点批号',
            prop: 'batchOrderNo',
            width: '230',
            align: 'center'
          },
          // {
          //   label: '盘点单',
          //   prop: 'orderNo',
          //   width: '230',
          //   align: 'center'
          // },
          {
            label: '条码',
            prop: 'barCode',
            width: '160',
            align: 'center'
          },
          // {
          //   label: '自编码',
          //   prop: 'artNo',
          //   width: '80',
          //   align: 'center'
          // },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '150',
            align: 'center'
          },
          {
            label: '盘点数量',
            prop: 'blitemNum',
            width: '120',
            align: 'center'
          },
          {
            label: '系统库存',
            prop: 'inventoryNum',
            width: '120',
            align: 'center'
          },
          {
            label: '盈亏数量',
            prop: 'quantityVariance',
            width: '120',
            align: 'center'
          },
          {
            label: '盈亏金额',
            prop: 'lossAmount',
            width: '120',
            align: 'center'
          },
          {
            label: '盘点金额',
            prop: 'amountInventory',
            width: '120',
            align: 'center'
          },
          {
            label: '商品类别',
            prop: 'goodsCategoryName',
            width: '120',
            align: 'center'
          },
          {
            label: '品牌',
            prop: 'brandName',
            width: '120',
            align: 'center'
          },
          {
            label: '供应商',
            prop: 'supplierName',
            width: '150',
            align: 'center'
          },
          // {
          //   label: '零售价',
          //   prop: 'retailPrice',
          //   width: '120',
          //   align: 'center'
          // },
          // {
          //   label: '成本价',
          //   prop: 'purchasePrice',
          //   width: '120',
          //   align: 'center'
          // },
        ],
        url: api.warehouse.differenceDetail,
        param: {reviewerStatus: 10}
      },
      // 楼盘
      beLostBlitem: {
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '200',
            align: 'center'
          },
          {
            label: '盘点批号',
            prop: 'batchOrderNo',
            width: '230',
            align: 'center'
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '230',
            align: 'center'
          },
          // {
          //   label: '自编码',
          //   prop: 'artNo',
          //   width: '80',
          //   align: 'center'
          // },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '150',
            align: 'center'
          },
          {
            label: '系统库存',
            prop: 'inventoryNum',
            width: '100',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '80',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '80',
            align: 'center'
          },
          {
            label: '商品类别',
            prop: 'goodsCategoryName',
            width: '100',
            align: 'center'
          },
          {
            label: '供应商',
            prop: 'supplierName',
            width: '150',
            align: 'center'
          },
          // {
          //   label: '零售价',
          //   prop: 'retailPrice',
          //   width: '80',
          //   align: 'center'
          // },
          // {
          //   label: '成本价',
          //   prop: 'purchasePrice',
          //   width: '80',
          //   align: 'center'
          // },
        ],
        url: api.warehouse.beLostDetail,
        param: {reviewerStatus: 10}
      },
    };
  },
  created() {
    this.title = document.title;
    this.setStore(this.searchOptions.complex);
    let userInfo = this.$utils.getSysUser();
    if (userInfo.storeId) {
      this.storeChange(userInfo)
    }
  },
  mounted() {
  },
  methods: {
    // 选择门店
    storeChange(form) {
      form.goodsBrandId = '';
      form.supplierId = '';
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      })
    },
    searchSubmit(param) {
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    tabChange() {
      if (this.activeTab === "blitem") {
        this.num = 1;
      } else if (this.activeTab === "difference") {
        this.num = 2;
      } else if (this.activeTab === "beLostBlitem") {
        this.num = 3;
      }
      this.$refs[this.activeTab].operationSuccess();
    },
    clearSearch() {
      this.$refs['blitem'].clearSearch();
      this.$refs['difference'].clearSearch();
      this.$refs['beLostBlitem'].clearSearch();
      let userInfo = this.$utils.getSysUser();
      if (!userInfo.storeId) {
        this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
      }
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let url, fileName, param;
      let searchParam = {reviewerStatus: 10};
      switch (this.activeTab) {
        case 'blitem':
          param = this.$refs["blitem"].searchParam;
          url = api.warehouse.blitemDetailExport;
          fileName = '盘点明细_';
          break;
        case 'difference':
          param = this.$refs["difference"].searchParam;
          url = api.warehouse.differenceDetailExport;
          fileName = '盘点差异_';
          break;
        case 'beLostBlitem':
          param = this.$refs["beLostBlitem"].searchParam;
          url = api.warehouse.beLostDetailExport;
          fileName = '盘点漏盘_';
          break;
      }
      Object.assign(searchParam, param);
      this.$axios.PostBlob(url, searchParam).then(res => {
        if (res.status === 200) {
          fileName = fileName + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName;//下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
  }
}
</script>

<style scoped>
>>> .el-tabs--top {
  margin-top: -14px;
}
</style>



// WEBPACK FOOTER //
// src/page/warehouse/inventory/Statement.vue